import { render, staticRenderFns } from "./jnbkb.vue?vue&type=template&id=4a2a623a&scoped=true&"
import script from "./jnbkb.vue?vue&type=script&lang=js&"
export * from "./jnbkb.vue?vue&type=script&lang=js&"
import style0 from "./jnbkb.vue?vue&type=style&index=0&id=4a2a623a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a623a",
  null
  
)

export default component.exports